<template>
  <div class="switchParkDialog">
    <!-- 切换园区 -->
    <el-dialog
        title="切换企业/园区"
        :visible.sync="dialogParams.dialogVisible"
        :before-close="beforeClose"
        @open="open">
      <el-form
          :model="form"
          ref="ruleForm"
          status-icon
          label-width="120px"
          label-position="left"
          v-if="list.length"
      >
        <el-form-item label="切换企业为">
          <el-select v-model="form.enterprise_id" placeholder="请选择企业" @change="selceted">
            <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="切换园区为">
          <el-select v-model="form.incubator_id" placeholder="请选择园区">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('change')">确 定</el-button>
        <el-button @click="beforeClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props:{
      dialogParams:{
        type: Object
      }
    },
    data(){
      return{
        form: {
          enterprise_id: "",
          incubator_id: ""
        },
        list: [], //企业
        list2: [] //园区
      }
    },
    methods:{
      open(){
        this.getUserEnterprise(); //查询已认证企业
      },
      /*提交用户信息*/
      submit(type){
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            // type === 'default' && this.setUserDefaultIncubator();
            // type === 'change' && this.setUserSelectIncubator();
            this.setIncubator();
            /* 更新用户信息 */
          } else {
            return false;
          }
        });
      },
      async setIncubator(){
        // await this.setUserDefaultIncubator();
        await this.setUserSelectIncubator();
        await this.common.getParkInfo(true);
        await this.common.getEnterpriseInfo();
        window.location.reload();
      },
      // 切换当前企业园区
      setUserSelectIncubator() {
        let params = {
          enterprise_id: this.form.enterprise_id,
          incubator_id: this.form.incubator_id
        };
        return this.api.setUserSelectIncubator(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.$message.success('设置成功！');
          // this.common.getParkInfo(true);
          // window.location.reload(true);
        });
      },
      // 设置默认企业园区
      setUserDefaultIncubator() {
        let params = {
          enterprise_id: this.form.enterprise_id,
          incubator_id: this.form.incubator_id
        };
        return this.api.setUserDefaultIncubator(params).then(res => {
          if (res.error.err_code !== 0) return;
          // this.$message.success('设置成功！');
          // this.common.getEnterpriseInfo();
        });
      },
      // 选择企业
      selceted(val) {
        this.getIncubators();
      },
      // 根据企业查询园区
      getIncubators() {
        let params = {
          enterprise_id: this.form.enterprise_id,
          pageNo: 0,
          pageSize: 99
        };
        this.api.getUserIncubator(params).then(res => {
          if (res.error.err_code !== 0) return;
          let list2 = res.obj.list || [];
          this.list2 = list2;
          list2.forEach(item => {
            if (item.is_default) {
              this.form.incubator_id = item.id;
            }
          });
        });
      },
      //查询已认证企业
      getUserEnterprise() {
        this.api.getUserEnterprise().then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list || [];
          list.forEach(item => {
            if (item.is_default) {
              this.form.enterprise_id = item.id;
              this.getIncubators();
            }
          });
          this.list = list;
        });
      },
      beforeClose(){
        Object.assign(this.$data, this.$options.data());
        this.dialogParams.dialogVisible = false;
      }
    }
  }
</script>

<style lang="scss">
.switchParkDialog{
  .el-dialog{
    width: 560px;
  }
  .el-input-240{
    width: 240px !important;
  }
  .el-form-item{
    .el-form-item__label{
      padding-bottom: 0;
    }
  }
  // 上传样式start
  .myupload {
    display: flex;

    .myupload_r {
      margin-left: 10px;
      font-size: 12px;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      p {
        white-space: normal;
        line-height: 18px;
      }
    }

  }
}
</style>
